import React from 'react';

const KYC = () => {
  return <h2>KYC Management Page</h2>;
};

export default KYC;
